export default "__VITE_ASSET__c5b15fca__"